import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';

function calculateLeft(size) {
  if (size === 'small') {
    return calculateRem(25);
  } else {
    return calculateRem(28);
  }
}

var StyledAnchor = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-1bjel3a-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: 1rem;\n  height: ", ";\n  width: ", ";\n  ", ";\n  &:hover {\n    outline: none;\n  }\n"])), function (_ref) {
  var size = _ref.size;
  return size === 'small' ? calculateRem(20) : calculateRem(24);
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? calculateRem(49) : calculateRem(52);
}, function (_ref3) {
  var focusState = _ref3.focusState,
      colorConfig = _ref3.colorConfig,
      inverted = _ref3.inverted,
      disabled = _ref3.disabled;
  return focusState && !inverted && !disabled ? "\n    &:focus:not(:hover) {\n      outline: none;\n      &::before {\n        border: ".concat(calculateRem(1), " dashed ").concat(colorConfig.black, ";\n        box-sizing: border-box;\n        border-radius: 1rem;\n        content: '';\n        height: calc(100% + ").concat(calculateRem(6), ");\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: calc(100% + ").concat(calculateRem(6), ");\n      }\n    }\n  ") : focusState && inverted && !disabled ? "\n      &:focus:not(:hover) {\n        outline: none;\n        &::before {\n          border: ".concat(calculateRem(1), " dashed ").concat(colorConfig.white, ";\n          box-sizing: border-box;\n          border-radius: 1rem;\n          content: '';\n          height: calc(100% + ").concat(calculateRem(6), ");\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat(calculateRem(6), ");\n        }\n      }\n      ") : "\n    &:focus:not(:hover) {\n      outline: -webkit-focus-ring-color auto 5px;\n    }\n  ";
});
var ToggleSwitchSlider = /*#__PURE__*/styled.span.withConfig({
  displayName: "ToggleSwitchSlider",
  componentId: "sc-1bjel3a-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 1rem;\n  border: ", " solid transparent;\n  box-sizing: border-box;\n  position: relative;\n  display: ", ";\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  height: ", ";\n  transition: background-color\n    ", ";\n  transition-timing-function: ", ";\n  width: ", ";\n  &::before {\n    background-color: ", ";\n    border-radius: 50%;\n    bottom: 0;\n    content: '';\n    height: ", ";\n    left: ", ";\n    margin-bottom: auto;\n    margin-top: auto;\n    padding-left: 0;\n    position: absolute;\n    top: 0;\n    transition: ", ";\n    width: ", ";\n    z-index: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), calculateRem(2), function (_ref4) {
  var hasLabels = _ref4.hasLabels;
  return hasLabels ? 'inline-block' : 'inline-flex';
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? null : 'pointer';
}, function (_ref6) {
  var calculateBackgroundColor = _ref6.calculateBackgroundColor,
      disabled = _ref6.disabled,
      on = _ref6.on,
      inverted = _ref6.inverted;
  return calculateBackgroundColor(disabled, on, inverted);
}, function (_ref7) {
  var calculateTextColor = _ref7.calculateTextColor,
      disabled = _ref7.disabled,
      on = _ref7.on,
      inverted = _ref7.inverted;
  return calculateTextColor(disabled, on, inverted);
}, function (_ref8) {
  var size = _ref8.size;
  return size === 'small' ? calculateRem(20) : calculateRem(24);
}, function (_ref9) {
  var size = _ref9.size;
  return size === 'small' ? '250ms' : '100ms';
}, function (_ref10) {
  var size = _ref10.size;
  return size === 'large' && 'cubic-bezier(0.4, 0.0, 0.2, 1.0)';
}, function (_ref11) {
  var size = _ref11.size;
  return size === 'small' ? calculateRem(49) : calculateRem(52);
}, function (_ref12) {
  var calculateButtonColor = _ref12.calculateButtonColor,
      disabled = _ref12.disabled,
      inverted = _ref12.inverted;
  return calculateButtonColor(disabled, inverted);
}, function (_ref13) {
  var size = _ref13.size;
  return size === 'small' ? calculateRem(18) : calculateRem(20);
}, function (_ref14) {
  var size = _ref14.size;
  return size === 'small' ? calculateRem(-1) : 0;
}, function (_ref15) {
  var size = _ref15.size;
  return size === 'small' ? 'left 250ms' : 'left 100ms';
}, function (_ref16) {
  var size = _ref16.size;
  return size === 'small' ? calculateRem(18) : calculateRem(20);
}, function (_ref17) {
  var hideText = _ref17.hideText,
      hideLabels = _ref17.hideLabels,
      size = _ref17.size,
      statusText = _ref17.statusText,
      calculateFontWeight = _ref17.calculateFontWeight;
  return !hideText && !hideLabels && "\n    &::after {\n      content: 'Off';\n      font-size: ".concat(calculateRem(statusText.fontSize), ";\n      font-weight: ").concat(calculateFontWeight, ";\n      line-height: ").concat(calculateRem(statusText.lineHeight), ";\n      font-family: ").concat(statusText.fontFamily, ";\n      position: absolute;\n      right: ").concat(size === 'small' ? calculateRem(5) : calculateRem(4), ";\n      top: ").concat(size === 'small' ? calculateRem(2) : calculateRem(3), ";\n      z-index: 0;\n    }\n\n  ");
}, function (_ref18) {
  var on = _ref18.on,
      size = _ref18.size,
      disabled = _ref18.disabled;
  return on && "\n    transition: background-color ".concat(size === 'small' ? '250ms' : '100ms', ";\n    transition-timing-function: ").concat(size === 'large' && 'cubic-bezier(0.4, 0.0, 0.2, 1.0)', ";\n    &::before {\n      content: '';\n      left: ").concat(calculateLeft(), " !important; \n      transition: left ").concat(size === 'small' ? '250ms' : '100ms', "; \n    }\n  ");
}, function (_ref19) {
  var hideText = _ref19.hideText,
      hideLabels = _ref19.hideLabels,
      on = _ref19.on,
      size = _ref19.size,
      calculateTextColor = _ref19.calculateTextColor,
      disabled = _ref19.disabled,
      inverted = _ref19.inverted;
  return on && !hideText && !hideLabels && "\n    &::after {\n      color: ".concat(calculateTextColor(disabled, on, inverted), ";\n      content: 'On';\n      left: ").concat(size === 'small' && calculateRem(7), ";\n      right: ").concat(size === 'small' ? 'auto' : calculateRem(24), ";\n      top: ").concat(size === 'large' && calculateRem(3), ";\n      z-index: 0;\n  }\n  ");
});
var ToggleInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "ToggleInput",
  componentId: "sc-1bjel3a-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: 0;\n  margin: 0;\n  width: 2rem;\n  height: 1rem;\n  position: absolute;\n  top: 0;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var propTypes = {
  on: PropTypes.bool,
  disabled: PropTypes.bool,
  hideText: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  hasLabels: PropTypes.bool,
  name: PropTypes.string,

  /**
   * @ignore
   * String that determines size of Toggle, small or large
   */
  size: PropTypes.oneOf(['small', 'large']),

  /**
   * @ignore
   * Object containing strings of colors in hex
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   * Function that determines text color of Toggle
   */
  calculateTextColor: PropTypes.func,

  /**
   * @ignore
   * Object that contains font styles
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * Number that determines font weight
   */
  calculateFontWeight: PropTypes.number,

  /**
   * @ignore
   * Function that determines background color of Toggle
   */
  calculateBackgroundColor: PropTypes.func,

  /**
   * @ignore
   * Function that determines background color of Toggle button
   */
  calculateButtonColor: PropTypes.func,

  /**
   * @ignore
   * String that determines typescale used for on/off labels
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * Boolean that renders a new focus state
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  //Deprecated
  checked: PropTypes.bool
};
var defaultProps = {
  on: false,
  disabled: false,
  hideText: false,
  onClick: function onClick() {},
  onKeyPress: function onKeyPress() {},
  onChange: function onChange() {},
  hasLabels: false,
  name: null,
  bodyConfig: BodyConfig,
  colorConfig: colors,
  calculateFontWeight: 750,
  typescale: TypographyConfig.getTypescale(),
  focusState: false //Deprecated
  //checked: false

};
/**
 * @ignore
 */

var ToggleSwitch = function ToggleSwitch(_ref20) {
  var checked = _ref20.checked,
      onProp = _ref20.on,
      disabled = _ref20.disabled,
      hideText = _ref20.hideText,
      onClick = _ref20.onClick,
      onKeyDown = _ref20.onKeyDown,
      onChange = _ref20.onChange,
      tabIndex = _ref20.tabIndex,
      hasLabels = _ref20.hasLabels,
      name = _ref20.name,
      value = _ref20.value,
      colorConfig = _ref20.colorConfig,
      calculateTextColor = _ref20.calculateTextColor,
      calculateBackgroundColor = _ref20.calculateBackgroundColor,
      calculateButtonColor = _ref20.calculateButtonColor,
      bodyConfig = _ref20.bodyConfig,
      typescale = _ref20.typescale,
      calculateFontWeight = _ref20.calculateFontWeight,
      size = _ref20.size,
      focusState = _ref20.focusState,
      analyticsTrack = _ref20.analyticsTrack,
      track = _ref20.track,
      clickStream = _ref20.clickStream,
      inverted = _ref20.inverted,
      inputId = _ref20.inputId,
      focusId = _ref20.focusId;
  var on = onProp;
  var statusText = bodyConfig.getStyles(typescale, 'desktop', 'small');
  return /*#__PURE__*/React.createElement(StyledAnchor, {
    id: focusId,
    disabled: disabled,
    inverted: inverted,
    focusState: focusState,
    colorConfig: colorConfig,
    tabIndex: disabled ? -1 : 0,
    size: size
  }, /*#__PURE__*/React.createElement(ToggleInput, {
    "data-testid": "test-toggle",
    type: "checkbox",
    checked: on,
    disabled: disabled,
    name: name,
    value: value,
    onChange: onChange,
    onKeyDown: onKeyDown,
    tabIndex: -1,
    "aria-hidden": "true",
    id: inputId ? inputId : name ? name : 'toggle',
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-clickstream": clickStream
  }), /*#__PURE__*/React.createElement(ToggleSwitchSlider, {
    inverted: inverted,
    disabled: disabled,
    on: on,
    hideText: hideText,
    name: name,
    hasLabels: hasLabels,
    "aria-label": name ? name + ' Toggle' + (on ? ' on' : ' off') : ' Toggle' + (on ? ' on' : ' off'),
    role: "switch",
    "aria-selected": on,
    "aria-live": "assertive",
    colorConfig: colorConfig,
    calculateTextColor: calculateTextColor,
    calculateBackgroundColor: calculateBackgroundColor,
    calculateButtonColor: calculateButtonColor,
    statusText: statusText,
    calculateFontWeight: calculateFontWeight,
    size: size
  }));
};

ToggleSwitch.propTypes = propTypes;
ToggleSwitch.defaultProps = defaultProps;
export default ToggleSwitch;